// @flow
import Enum from './Enum';

import type { VisitSourceEnum as VisitSourceEnumType } from 'common/models/flow/Plan';

export const CreateTaskVisitTypesEnum = new Enum({
    Pickup: 'PICKUP',
    Drop: 'DROP',
    Service: 'SERVICE'
});

export const VisitTypeEnum = new Enum({
    Homebase: 'HOMEBASE',
    Customer: 'CUSTOMER',
    Pickup: 'PICKUP',
    Drop: 'DROP',
    User: 'USER'
});

export const ExchangeTypeEnum = new Enum({
    Collect: 'COLLECT',
    Give: 'GIVE',
    None: 'NONE'
});

export const ExchangeTypeDisplayEnum = new Enum({
    COLLECT: 'COLLECT',
    GIVE: 'GIVE',
    NONE: 'PAID'
});

export const VisitStatusEnum = {
    Waiting: 'WAITING',
    Queued: 'QUEUED',
    Travelling: 'TRAVELLING',
    Transacting: 'TRANSACTING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Mixed: 'MIXED'
};

export const UserVisitTypeEnum = {
    ShiftStart: 'SHIFT_START',
    ShiftEnd: 'SHIFT_END',
    TourEnd: 'TOUR_END',
    Break: 'BREAK',
    Service: 'SERVICE',
    Other: 'OTHER',
    None: 'NONE',
    StartOfDay: 'START_OF_DAY',
    EndOfDay: 'END_OF_DAY'
};

export const BreakTypeEnum = {
    Lunch: 'LUNCH',
    Refuel: 'REFUEL',
    Night: 'NIGHT',
    OTHER: 'OTHER'
};

export const PodTypeEnums = {
    Boolean: 'BOOLEAN',
    SingleChoice: 'SINGLE_CHOICE',
    TextField: 'TEXT_FIELD',
    Pin: 'PIN',
    Signature: 'SIGNATURE',
    Photo: 'PHOTO',
    Rating: 'RATING',
    Url: 'URL',
    Date: 'DATE',
    Time: 'TIME',
    DateTime: 'DATETIME',
    Comment: 'COMMENT',
    Select: 'SELECT',
    PhotoGallery: 'PHOTO_GALLERY',
    MultiChoice: 'MULTI_CHOICE'
};

export const AppFieldEnums = {
    Url: 'URL',
    Text: 'TEXT'
};

export const NotesInputFieldsEnums = new Enum({
    Url: 'URL',
    UrlName: 'URL_NAME',
    Text: 'TEXT',
    Format: 'format'
});

export const ConfidenceEnum = new Enum({
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW'
});

export const TransactionStatusTypeEnum = new Enum({
    Delivered: 'DELIVERED',
    NotDelivered: 'NOT_DELIVERED',
    PartiallyDelivered: 'PARTIALLY_DELIVERED'
});

export const TransactionTypeEnum = new Enum({
    Pickup: 'PICKUP',
    Drop: 'DROP'
});

export const BulkAddableVisitFieldsEnum = new Enum({
    Name: 'CONTACT_NAME',
    ContactNumber: 'CONTACT_NUMBER',
    AlternateNumber: 'ALTERNATE_NUMBER',
    Notes: 'NOTES'
});

export const VisitColumnType = new Enum({
    Resource: 'Resource'
});

export const VisitSourceEnum: {
    [key: VisitSourceEnumType]: string
} & Enum = new Enum({
    USER: 'USER',
    TASK: 'TASK',
    TOUR: 'TOUR'
});

export const ChecklistTypeEnum = new Enum({
    Cancelled: 'CANCELLED',
    Completed: 'COMPLETED',
    Started: 'STARTED',
    Arrived: 'ARRIVED',
    Transacting: 'TRANSACTING'
});

export const TaskSource = {
    ONDEMAND: 'ONDEMAND'
};

export const EventComponentTypes = {
    TASK_VISIT: 'TASK_VISIT',
    OPERATION_SHIFT: 'OPERATION_SHIFT',
    HOMEBASE: 'HOMEBASE',
    BREAK: 'BREAK',
    LUNCH: 'LUNCH',
    NIGHT: 'NIGHT',
    REFUEL: 'REFUEL',
    SHIFT_START_VISIT: 'SHIFT_START_VISIT',
    SHIFT_END_VISIT: 'SHIFT_END_VISIT',
    TOUR_BACKGROUND: 'TOUR_BACKGROUND',
    PICKUP: 'PICKUP',
    DROP: 'DROP'
};
